import React from 'react';
import PaymentsBrowser from '@/components/shared/PaymentsBrowser';

/** Admin view: read-only + refund actions. */
export default function AdminPayments() {
  return <PaymentsBrowser endpoint="/admin/payments" canRefund={true} testIdPrefix="admin-payments" />;
}
